<template>
  <div id="main" class="productCenter">
    <topNav></topNav>
    <div class="inner" v-if="showNav.Big == 'DA' && showNav.small == 'a1'">
      <div class="demobox bigNav">
        <!-- <img
          src="../../common/images/productCenter/ddzb/d26822.png"
          class="bigNav-img"
          alt=""
        /> -->
      <el-carousel trigger="click" class="bannerMain" :interval="10000" v-show="banners.length>1">
        <el-carousel-item v-for="(item,index) in banners" :key="index">
          <div class="banner2">
            <img :src="item" class="bannerimg2" alt="" />
            <!-- <img :src="item.imgSrc" class="bannerimg" alt="" /> -->
          </div>
        </el-carousel-item>
      </el-carousel>
      <img :src="banners[0]" class="bannerimg2" v-show="banners.length<=1" alt="" />
      </div>
      <div class="hexing">
          <!-- <span class="xlk" @click="wenzi(0)">核心优势</span>
          <span class="" @click="wenzi(1)">产品亮点</span> -->
      <span v-for="(item,index) in anNiu" :key="index" v-show="item.name" :class="{ xlk: linkIndex == item.name ? true : false }"  @click="wenzi(item)">{{item.name}}</span>
      </div>

      <div class="banner2" v-for="(item,index) in anNiu" :key="index" :id="item.id">
          <img :src="item.pictures" alt="" class="bannerimg2">
      </div>

      <!-- <div class="demobox banner bannera1" id="banner" @click="ceshi()">
          <img src="../../common/images/productCenter/ddzb/d26823.png"  alt="">
      </div> -->

      <!-- <div class="demobox banner2 bannera1" id="banner2">
          <img src="../../common/images/productCenter/ddzb/d26824.png" alt="">
      </div> -->

    </div>
    <Bottoms></Bottoms>
  </div>
</template>

<script>
import topNav from "../sub/topNav";
import Bottoms from "../sub/Bottoms";
import { l } from "@/utils/tool";
import { colunmList,productList,columnTypeList } from "@/api/topNav.js";
export default {
  name: "ddzb",
  components: { topNav, Bottoms },
  data() {
    return {
      linkIndex:'',
      showNav: {
        Big: "DA",
        small: "a1",
      },
      videoDAsrc: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/zb.mp4",
      videoDBsrc: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/jy.mp4",
      palyDA: true,
      palyDB: true,
      playingA: false,
      playingB: false,
      banners: [
        // {
        //   imgSrc: "https://dexun-www.oss-cn-shenzhen.aliyuncs.com/yzsm.png",
        //   key: 1,
        //   to: true,
        //   // url: "https://www.dexunzhenggu.cn/h5/html/showimg.html?id=1",
        //   url: "https://www.dexunzhenggu.cn/h5/html/showimg.html?id=1",
        // },
        // {
        //   imgSrc: "https://dexun-www.oss-cn-shenzhen.aliyuncs.com/515.png",
        //   key: 2,
        //   to: false,
        //   url: "",
        // },
        // {
        //   imgSrc:
        //     "https://dexun-www.oss-cn-shenzhen.aliyuncs.com/znqbanner.jpg",
        //   key: 3,
        //   to: false,
        //   url: "",
        // },
      ],
      anNiu:['https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/yzsm.png'],
    };
  },
  // created(){
  // },
  mounted() {
      // l(sessionStorage.getItem('linkIndex'),'ddzb');
      this.selectf();
  },
  methods: {
      wenzi(item){ //锚链接跳转
      this.linkIndex = item.name;
      let bannerID = document.getElementById(item.id);
      if(bannerID) window.scroll(0,(bannerID.offsetTop-89));
        // let banner = document.getElementById('banner');
        // let banner2 = document.getElementById('banner2');
        // let items = document.querySelector('.hexing').children;
        // console.log(banner.offsetTop);
        // if(item==0){
        //     // banner.animate({scrolTop:100});
        //     // banner.scrollIntoView();
        //     // window.screenTop(0,10);
        //     window.scroll(0,(banner.offsetTop-89));
        //     items[0].classList.add('xlk');
        //     items[1].classList.remove('xlk');
        // }else{
        //    window.scroll(0,(banner2.offsetTop-89));
        //     items[1].classList.add('xlk');
        //     items[0].classList.remove('xlk');
        //     // document.getElementById('banner2').scrollIntoView();
        // }
      },
      selectf(){
        productList({ status: 1,name:this.$route.query.name }).then((res) => { //产品管理列表
        //列表
        if (res.code == 200) {
          let arr = [];
          // res.data.list.forEach((v) => {
          //   v.PSons.forEach(v2=>{
          //     arr.push(v2.pictures);
          //   })
          // });
          this.anNiu = res.data.list[0].PSons;
          // this.jiazaiLy();
          this.banners = res.data.list[0].Product.pictures.split(',');
          l(this.banners);
          this.wenzi(this.anNiu[0])
        }
      });
      },
      ceshi(){

      },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  text-align: center;
}
.inner{
  overflow: hidden;
}
.bannerMain >>> .el-carousel__container {
  width: 100%;
  height: 496px !important;
}
.bannerimg {
  display: block;
  /* width: 100%; */
  max-width: 1920px;
  /* height: 496px !important; */
  margin: auto;
  position: relative;
}
.bannerimg2 {
    display: block;
    /* width: 100%; */
    max-width: 1920px;
    /* height: 100%; */
    margin: auto;
}
.demobox {
  width: 100%;
  height: 600px;
  overflow: hidden;
}
.boxin {
  width: 1226px;
  /* overflow: hidden; */
  margin: 0 auto;
}
.bigNav {
  max-width: 1920px;
  height: 496px;
  margin: auto;
}
.bigNav .bigNav-img {
  width: 100%;
  height: 496px;
}
.bigNavbox {
  width: 1226px;
  height: 88px;
  border-bottom: 1px solid #dcdcdc;
  display: flex;
  justify-content: space-between;
  padding: 0 108px;
  box-sizing: border-box;
  z-index: 5;
}
.NavD {
  width: 400px;
  height: 100%;
  z-index: 10;
  box-sizing: border-box;
  cursor: pointer;
}
.NavD span {
  display: block;
  width: 136px;
  height: 48px;
  margin: 0 auto;
  margin-top: 30px;
  font-size: 34px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #888;
  opacity: 1;
}
.NavD span:hover {
  color: #e7413b;
}
.isBnav {
  border-bottom: 2px solid #e7413b;
}
.isBnav span {
  color: #e7413b;
}
.banner {
  height: 5037px;
  position: relative;
}
/* #banner{
  position: absolute;
  width: 100px;
  height: 100px;
  top: -160px;
  background-color: #fff;
  z-index: 999;
} */
.banner2{
  width: 1920px;
  margin: auto;
  overflow: hidden;
    /* height: 1436px; */
}
.wenzi {
  position: absolute;
  right: 22.5%;
  bottom: 38%;
}

.tougu{
  position: absolute;
  right: 61.3%;
  bottom: 29%;
}
.tougu a{
  color: #DFB283 !important;
  border-bottom: 1px solid #DFB283 !important;
}
.shift{
  right: 27.5% !important;
  bottom: 38% !important;
}
.wenzi a {
  color: #228efb;
  font-size: 18px;
  font-weight: 600;
  margin-right: 50px;
  border-bottom: 1px solid #228efb;
  padding-bottom: 4px;
}
.wenzi a:hover {
  cursor: pointer;
}
/* .bannera1 {
  background: url("../common/images/productCenter/A1/26818.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.bannera2 {
  background: url("../common/images/productCenter/A2/bannerback.png") no-repeat;
  background-size: 100% 100%;
}
.bannera3 {
  background: url("../common/images/productCenter/A3/bannerback.png") no-repeat;
  background-size: 100% 100%;
}
.bannerb1 {
  background: url("../common/images/productCenter/B1/bannerback.png") no-repeat;
  background-size: 100% 100%;
}
.bannerb2 {
  background: url("../common/images/productCenter/B2/bannerback.png") no-repeat;
  background-size: 100% 100%;
} */
.banmain {
  height: 460px;
}
.smallNav {
  position: relative;
}
.wenzi2 {
  position: absolute;
  right: 58.9%;
  bottom: 28%;
}
.wenzi2 a {
  color: #ff4b4f;
  font-size: 18px;
  font-weight: 600;
  margin-right: 50px;
  border-bottom: 1px solid #ff4b4f;
  padding-bottom: 4px;
}
.wenzi2 a:hover {
  cursor: pointer;
}
.smallNavbox {
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
  padding-bottom: 47px;
}
.Navd {
  width: 374px;
  height: 82px;
  background-color: #f5f5f5;
  border-radius: 6px;
  text-align: center;
  line-height: 82px;
  font-size: 34px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #888888;
  cursor: pointer;
}
.Navd:hover {
  color: #e7413b;
}
.isSnav {
  /* background: url("../common/images/productCenter/A1/isSnav.png") no-repeat; */
  background-size: 100% 100%;
  color: #fff;
}
.isSnav:hover {
  color: #fff;
}
.all .title {
  width: 100%;
  margin-top: 60px;
}
.all .title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.all .title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.all .title-b {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}
.hexing{
    width: 100%;
    max-width: 1920px;
    min-height: 40px;
    margin: auto;
    display: flex;
    justify-content: space-evenly;
    line-height: 80px;
}
.hexing span{
    font-family: PingFang SC-Regular;
    color: #333333;
    font-size: 26px;
    /* border-bottom: 1px solid #DE161E; */
    font-weight: 400;
    height: 80px;
    /* width: 160px; */
}
.hexing span:hover{
    cursor: pointer;
}
.xlk{
    border-bottom: 5px solid #DE161E;
    padding-bottom: 4px;
    color: #DE161E !important;
}
</style>



// WEBPACK FOOTER //
// src/components/productCenter/ddzb.vue